import { HttpClient } from "./http";

class Complaints extends HttpClient {
    constructor() {
        super()
    }

    public async getComplaintDetails(params: any) {
        return this.HTTP.get(`/fleet/complaint`, { params })
    }
    public async enableChargebackButton(transaction_id: any,type:any) {
        return this.HTTP.get(`/fleet/transaction/${transaction_id}/eligible-amount?type=${type}`)
    }
     public async adjustmentEnableChargebackButton(transaction_id: any,type:any) {
        return this.HTTP.get(`/fleet/transaction/${transaction_id}/eligible-amount?type=${type}`)
    }
}

export const ComplaintsService = new Complaints();
